<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
    name: 'LocaleSwitcher',
});
</script>
<template>
    <b-nav-item-dropdown
        id="dropdown-grouped"
        variant="link"
        class="dropdown-language"
        right
    >
        <template #button-content>
            <b-img
                :src="currentLocale.img"
                height="14px"
                width="22px"
                :alt="currentLocale.locale"
            />
            <span class="ml-50 text-body d-none d-lg-inline-block">{{ currentLocale.name }}</span>
        </template>
        <b-dropdown-item
            v-for="localeObj in locales"
            :key="localeObj.locale"
            @click="setLocale(localeObj.locale)"
        >
            <b-img
                :src="localeObj.img"
                height="14px"
                width="22px"
                :alt="localeObj.locale"
            />
            <span class="ml-50">{{ localeObj.name }}</span>
        </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script setup lang="ts">import { ref as _ref, computed as _computed } from 'vue';

import { useI18n } from 'vue-i18n-bridge'
import { useLocalStorage } from '@vueuse/core'
import enFlagImg from '@/assets/images/flags/en.png'
import esFlagImg from '@/assets/images/flags/es.png'
import { configureLanguage } from '@/libs/i18n'
import { DEFAULT_LANGUAGE } from '@/module/shared/constants/locale'

// TODO: Change this when the refactor of the config is done
const lang = useLocalStorage('language', DEFAULT_LANGUAGE)

const locales = _ref([
    {
        locale: 'es',
        img: esFlagImg,
        name: 'Español',
    },
    {
        locale: 'en',
        img: enFlagImg,
        name: 'English',
    },
])
const localesMap = _computed(
    () =>
        locales.value.reduce((acc, locale) => {
            acc[locale.locale] = locale
            return acc
        }, {}) as Record<string, (typeof locales)[number]>
)

const i18n = useI18n()

const currentLocale = _computed(() => localesMap.value[i18n.locale.value])

const setLocale = (locale: string) => {
    i18n.locale.value = locale
    configureLanguage(locale)
    lang.value = locale
}


</script>
